// @flow

import React, { Component, type ComponentType } from 'react';

type State = {|
  componentDidCatchError: boolean,
|};

const withErrorBoundary = <Props: {}>(
  WrappedComponent: ComponentType<Props>,
): ComponentType<Props> => class WithErrorBoundary extends Component<Props, State> {
    constructor() {
      super();
      this.state = {
        componentDidCatchError: false,
      };
    }

    componentDidCatch() {
      this.setState({ componentDidCatchError: true });
    }

    render() {
      const { componentDidCatchError } = this.state;
      if (componentDidCatchError) {
        console.warn(
          'Ended up in withErrorBoundary.',
          'WrappedComponent:',
          WrappedComponent.displayName,
          'props:',
          this.props,
        );
        return null;
      }

      return <WrappedComponent {...this.props} />;
    }
  };

export default withErrorBoundary;
